var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("NavBar", { attrs: { pageName: _vm.pageName } }),
      _vm._v(" "),
      !_vm.grid
        ? _c("div", { staticClass: "main-container" }, [
            _c("div", { staticClass: "left-panel" }, [
              _c(
                "div",
                { staticClass: "slot-content-left" },
                [_vm._t("left")],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right-panel" }, [
              _c(
                "div",
                { staticClass: "slot-content-right" },
                [_vm._t("right")],
                2
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.grid
        ? _c("div", { staticClass: "main-container" }, [
            _c(
              "div",
              {
                class: {
                  "left-grid-panel": !_vm.fullPanel,
                  "left-grid-panel-full": _vm.fullPanel
                }
              },
              [
                _c(
                  "div",
                  {
                    class: {
                      "top-left-slot": !_vm.fullPanel,
                      "top-left-slot-full": _vm.fullPanel
                    }
                  },
                  [_vm._t("top-left")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bottom-left-slot" },
                  [_vm._t("bottom-left")],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "right-grid-panel" }, [
              _c(
                "div",
                { staticClass: "top-right-slot" },
                [_vm._t("top-right")],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bottom-right-slot" },
                [_vm._t("bottom-right")],
                2
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe728f86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe728f86","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/_Organisms/ManagementPage.vue
// module id = null
// module chunks = 